import { getAuthHeaders } from '../../../actions/authActions';
import tempMeeApi from '../../../apis/tempMee';

/**
 * Update candidate status
 *
 * @param {import('../types/UpdateCandidateStatus.parameters').IUpdateCandidateStatusPayload} payload - Request payload
 * @returns {Promise<void>} No content response
 */
export const updateCandidateStatus = async ({ candidateIds, status }) => {
  const headers = await getAuthHeaders();
  await tempMeeApi.patch(
    '/recruitment-service/admin/candidates/statuses',
    { candidateIds, status },
    { headers },
  );
};
